<template>
  <CustomVueEditor class="editor w-100" :modelTypeId="LESSON_TEXT_MODEL_TYPE" v-model="content"> </CustomVueEditor>
</template>

<style lang="scss">
.editor {
  .ql-toolbar {
    border: none !important;
  }
  .ql-container {
    border: none !important;
    border-top: 1px solid #dee2e6 !important;
  }
}
</style>

<script>
import CustomVueEditor from "shared/widgets/CustomVueEditor.vue";
import { LESSON_TEXT_MODEL_TYPE } from "shared/service/consts.js";

export default {
  name: "TextBlock",
  components: { CustomVueEditor },
  props: {
    value: null,
  },

  data() {
    return {
      content: this.value,
      inputTimerId: null,
    };
  },
  watch: {
    content() {
      this.$emit("input", this.content);
      clearTimeout(this.inputTimerId);
      this.inputTimerId = setTimeout(() => {
        this.$emit("update", this.content);
      }, 1000);
    },
  },
  created() {
    this.LESSON_TEXT_MODEL_TYPE = LESSON_TEXT_MODEL_TYPE;
  },
};
</script>
